<template>
  <v-dialog
      scrollable
      v-model="visible"
      max-width="1100px"
      :fullscreen="fullscreen"
      :persistent="true">
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">
          处理到款
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs3>
              <div class="x-text-field">
                <label>对方单位/凭证编号/分录编号</label>
                <div>{{ item.dfdw }}<br/>{{ item.pznm }}/{{ item.flbh }}</div>
              </div>
            </v-flex>

            <v-flex xs3>
              <div class="x-text-field">
                <label>金额(元)/凭证日期</label>
                <div>{{ item.je | currency }}<br/>{{ item.pzrq }}</div>
              </div>
            </v-flex>

            <v-flex xs3>
              <div class="x-text-field">
                <label>认款人/认款日期</label>
                <div>{{ item.claimName }}<br/>{{ item.rkrq }}</div>
              </div>
            </v-flex>

            <v-flex xs3>
              <div class="x-text-field">
                <label>预算文件文号/资金性质</label>
                <div>{{ budgetFile || item.budgetFile }}<br/>{{ item.lkbz }}</div>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
        <v-form v-model="formValid" ref="formRef">
          <v-container style="max-width: initial;">
            <v-layout wrap>
              <v-flex xs12>
                <v-data-table
                    :headers="headers"
                    :items="item.claimItems"
                    hide-actions="">
                  <template slot="items" slot-scope="props">
                    <td>{{ props.index + 1 }}</td>
                    <td><span class="font-weight-bold">{{ props.item.projName }}</span><br/>{{ props.item.projNumber }}
                      / {{ props.item.projTypeName }}
                    </td>
                    <td><span class="font-weight-bold">{{ props.item.leaderName }}</span><br/>{{ props.item.deptName }}
                    </td>
                    <td>
                      <v-text-field
                          :key="props.item.dbid"
                          :rules="rules.amount"
                          v-model="item.claimItems[props.index].money"/>
                    </td>
                    <td>
                      <v-text-field
                          :key="props.item.dbid"
                          :rules="rules.amount"
                          v-model="item.claimItems[props.index].researchMoney"/>
                    </td>
                    <td>
                      <v-autocomplete
                          :rules="rules.required"
                          v-model="item.claimItems[props.index].fundPartitionId"
                          item-text="name"
                          item-value="dbid"
                          :items="partItems"/>
                    </td>

                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <!--
        <v-btn color="primary" @click.native="dialogImp = true" :disabled="importing || item.code !== 0">文本导入
        </v-btn>
        -->
        <v-tooltip top>
        <v-btn
            color="primary"
            slot="activator"
            @click.native="excelDialogImp = true"
            :disabled="importing || item.code !== 0">
          <v-icon dark>table_chart</v-icon>导入项目经费分配Excel表
        </v-btn>
          <span>
            操作提示：导入经费分配项目明细后，点击分配到款按钮进行经费分配，然后重新进入该页面，点击批量建帐按钮完成经费的批量建帐！
          </span>
        </v-tooltip>
        <v-spacer/>
        到款金额：{{ item.je | currency }} / 合计：{{ sumMoney | currency }} / 差额：{{ (item.je - sumMoney) | currency }}
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn
            color="primary"
            @click.native="onSave()"
            :disabled="importing || item.code !== 0 || (item.je - sumMoney) !== 0.0">
          <v-icon dark>exposure</v-icon>分配到款
        </v-btn>
        <v-btn color="primary" @click.native="onPartition"
               :disabled="item.code !== 1">
          <v-icon dark>save_alt</v-icon>批量建帐
        </v-btn>
        <!--<v-btn color="primary" @click.native="onPush"
               :disabled="item.code !== 2"> 推送到财务
        </v-btn>--此段代码为原代码，根据中医大暂不对接财务需要，屏蔽此段代码！-->
      </v-card-actions>

      <v-dialog v-model="dialogImp" persistent max-width="700">
        <v-card>
          <v-card-title class="subheading">粘贴待解析的文本, 格式：批准号 金额</v-card-title>
          <v-progress-linear indeterminate :active="importing" height="2"/>
          <v-card-text class="pt-0">
            <v-layout wrap>
              <v-flex sm12>
                <v-text-field
                    label="预算文件及文号"
                    v-model="budgetFile"
                />
              </v-flex>
              <v-flex sm12>
                <v-textarea v-model="textInputs" outline style="min-height: 5em"/>
              </v-flex>
            </v-layout>
            <p>{{ impMsg }}</p>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="parseText()">分析Excel表格</v-btn>
            <v-spacer/>
            共读取出，项目：{{ parsedItemCount }}个，金额合计：{{ parsedItemSum | currency }}
            <v-spacer/>
            <v-btn color="primary" flat @click="dialogImp = false">取消</v-btn>
            <v-btn color="primary" @click="impParsedItems" :disabled="parsedItemCount === 0">导入</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="excelDialogImp" persistent max-width="900">
        <v-card>
          <v-card-title class="subheading">选择要导入的 Excel 文件</v-card-title>
          <v-progress-linear indeterminate :active="importing" height="2"/>
          <v-card-text class="pt-0">
            <v-layout wrap>
              <v-flex sm6 class="px-2">
                <v-text-field
                    id="_imp_text_file"
                    v-model="fileExcel"
                    label="Excel文件"
                    type="file"
                    @change.native="onDefaultPartIdChange"
                />
              </v-flex>

              <v-flex sm6 class="px-2">
                <v-text-field
                    label="预算文件及文号"
                    v-model="budgetFile"
                />
              </v-flex>

              <v-flex sm9 class="px-2">
                <v-autocomplete
                    label="默认经费拆分模板"
                    :rules="rules.required"
                    v-model="defaultPartId"
                    @change="onDefaultPartIdChange"
                    clearable
                    item-text="name"
                    item-value="dbid"
                    :items="partItems"/>
              </v-flex>

              <v-flex sm3 class="px-2">
                <v-autocomplete
                    label="资金性质"
                    v-model="item.lkbz"
                    clearable
                    @change="onDefaultPartIdChange"
                    item-text="name"
                    item-value="dbid"
                    :items="lkbzItems"/>
              </v-flex>

            </v-layout>
            <p>{{ impMsg }}</p>
          </v-card-text>
          <v-card-actions>
            <v-tooltip top>
            <v-btn
                color="primary"
                slot="activator"
                @click="parseExcel()"
                :disabled = disnaReadExcel
            >
              <v-icon dark>table_chart</v-icon>校验Excel表格
            </v-btn>
              <span>
            操作提示：选择Excel文件，指定经费分拆模版和资金性质后，点击本按钮校验Excel文件，校验通过，点击导入按钮导入项目！
          </span>
            </v-tooltip>
            <v-spacer/>
            共读取出，项目：{{ parsedItemCount }}个，金额合计：{{ parsedItemSum | currency }}
            <v-spacer/>
            <v-btn
                color="primary"
                href = "/api/proj/attachment/Gvaw48ZAAAA"
                target="_blank"
                download
            >
              <v-icon dark>cloud_download</v-icon>模版
            </v-btn>
            <v-btn color="primary"  @click="excelDialogImp = false">
              <v-icon dark >undo</v-icon>取消
            </v-btn>
            <v-btn color="primary" @click="impParsedItems" :disabled=disnaImport>
              <v-icon dark>input</v-icon>导入
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-dialog>
</template>
<script>
import mixin from '@/mixin';

/* load the codepage support library for extended support with older formats  */
import {read, set_cptable, utils} from "xlsx";
import _ from 'lodash';
import * as cptable from 'xlsx/dist/cpexcel.full.mjs';
import axios from "axios";

set_cptable(cptable);

const baseURI = '/api/proj/cw_lkxx';
const partURI = '/api/proj/fund/partition';
const projURI = '/api/proj/project';
const getProjUri = '/api/proj/project/if/project/exsist';

/** Excel Utils **/
const dc = utils.decode_cell,
    ec = (r, c) => {
      return utils.encode_cell({r: r, c: c});
    };

/**
 * Find a sheet in the workbook by name, and return an object with keys
 * `sheet` and `range`, where `range` is an object describing the valid cells
 * of the sheet, like `{min: {r: 1, c: 1}, max: {r: 5, c:5}}`.
 */
export function findSheet(workbook, sheetName) {
  let sheet = workbook.Sheets[sheetName],
      range = {min: {r: 0, c: 0}, max: {r: 0, c: 0}};

  if (!sheet) {
    return {sheet: null, range: null};
  }

  // find size of the sheet
  let ref = sheet['!ref'];

  if (!ref && ref.indexOf(':') === -1) {
    throw new Error("Malformed workbook - no !ref property");
  }

  range.min = dc(ref.split(':')[0]);
  range.max = dc(ref.split(':')[1]);

  return {sheet, range};
}

/**
 * Find the start position of a table in the given sheet. `colMap` describes
 * the table columns as an object with key prop -> column title. Returns an
 * object with keys `columns` (maps prop -> 0-indexed column number) and
 * `firstRow`, the number of the first row of the table (will be `null`) if the
 * table was not found.
 */
// colMap: prop -> col name
export function findTable(sheet, range, colMap) {
  let firstRow = null,
      colsToFind = _.keys(colMap).length,

      // colmap lowercase title -> prop
      colLookup = _.reduce(colMap, (m, v, k) => {
        m[_.isString(v) ? v.toLowerCase() : v] = k;
        return m;
      }, {}),

      // colmap props -> 0-indexed column
      columns = _.reduce(colMap, (m, v, k) => {
        m[k] = null;
        return m;
      }, {});

  // Look for header row and extract columns
  for (let r = range.min.r; r <= range.max.r - 1; ++r) {
    let colsFound = 0;

    for (let c = range.min.c; c <= range.max.c; ++c) {
      let cell = sheet[ec(r, c)];

      if (cell && cell.v !== undefined) {
        let prop = colLookup[cell.t === 's' ? cell.v.toLowerCase() : cell.v];
        if (prop) {
          columns[prop] = c;
          ++colsFound;
        }
      }
    }

    if (colsFound === colsToFind) {
      firstRow = r + 1;
      break;
    }
  }

  return {columns, firstRow};
}

/**
 * Given the `cols` and `firstRow` as returned by `findTable()`, return a list
 * of objects of all table values. Continues to the end of the sheet unless
 * passed a function `stop` that takes a mapped row object as an argument and
 * returns `true` for that row.
 */
export function readTable(sheet, range, columns, firstRow, stop) {
  let data = [];

  for (let r = firstRow; r <= range.max.r; ++r) {
    let row = _.reduce(columns, (m, c, k) => {
      let cell = sheet[ec(r, c)];
      m[k] = cell ? cell.v : null;
      return m;
    }, {});

    if (stop && stop(row)) {
      break;
    }

    data.push(row);
  }

  return data;
}

/**
 * Turn an Excel numeric date into a JavaScript Date object.
 */
export function convertExcelDate(excelDate) {
  return new Date((excelDate - (25569)) * 86400 * 1000);
}

/**
 * Turn a JavaScript Date into an Excel numeric date
 */
export function toExcelDate(jsDate) {
  return Number((jsDate.getTime() / (1000 * 60 * 60 * 24)) + 25569)
}

export default {
  mixins: [mixin.edit(baseURI)],
  props: ['value', 'uri', "dbid"],
  components: {},

  data() {
    return {
      formValid: false,
      dialogImp: false,

      excelDialogImp: false,
      fileExcel: null,

      importing: false,
      disnaImport: true,

      item: {"claimItems": []},
      freshItem: {"claimItems": []},

      headers: [
        {text: '#', sortable: false, value: 'rank', width: 18},
        {text: '项目名称/批准号', sortable: false, value: 'projName'},
        {text: '负责人/学院', sortable: false, value: 'leaderId', width: 200},
        {text: '到款金额（元）', sortable: false, value: 'money', width: 120},
        {text: '研究经费（元）', sortable: false, value: 'researchMoney', width: 120},
        {text: '经费拆分模板', sortable: false, value: 'name', width: 220},
      ],

      partItems: [],
      textInputs: "",
      parsedItems: [],

      // 默认经经费拆分模板
      defaultPartId: '',
      // 经费预算文号
      budgetFile: '',
      //资金性质
      lkbz: '',
      lkbzItems: ["财政","非财政","学校配套"],

      impMsg: "",

      // Excel 导入表单
      xlsxForm: {
        projNumberCol: '',

        projNumberValues: []
      },

      // Excel 表格列名
      xlsxColumns: [],

      //读取Excel表格按钮控制，只有选择了导入文件、经费分拆模版及资金性质才可以激活该按钮
      disnaReadExcel: true,

      /**
       * 验证规则
       */
      rules: {
        name: [
          v => !!v || '必填项。',
          v => (v && v.length <= 150) || '长度必须小于150个字符。'
        ],
        required: [
          v => !!v || '必填项。'
        ],
        amount: [
          v => !!v || '必填项。',
          v => (v && /^\d{1,10}?(\.[0-9][0-9]?)?$/ig.test(v)) || '填写数字，小数点后最多保留2位。',
          v => (v && Number(v) >= Number(this.item.researchFund || 0)) || "研究经费不能大于到款金额。"
        ],


        sumCheck: [
          v => !!v || '必填项。',
          v => (v && /^\d{1,10}?(\.[0-9][0-9]?)?$/ig.test(v)) || '填写数字，小数点后最多保留2位。',
          v => (v && (this.item.fundItems.filter(v => v.leaf === 1).map(v => v.amount || 0)
              .reduce((s, v) => s + Number(v), 0)) <= Number(this.item.researchFund) + 0.01) || "分拆科目总额不能超过研究费。"
        ],
      }
    }
  },
  computed: {
    sumMoney() {
      return this.item.claimItems.reduce((pv, cv) => pv + Number(cv.money), 0.0)
    },
    parsedItemCount() {
      return this.parsedItems.length;
    },
    parsedItemSum() {
      if (this.parsedItems.length === 0) return 0.0;
      return this.parsedItems.reduce((pv, cv) => pv + Number(cv.money), 0.0)
    }
  },

  created() {
    this.axios.get(partURI, {params: {limit: 9999}}).then(rsp => {
      this.partItems = rsp.data.items;
    });
    if (this.dbid) {
      this.axios.get(`${baseURI}/${this.dbid}`).then(rsp => {
        this.item = rsp.data;
      });
    }
  },

  methods: {
    parseText() {
      this.parsedItems = [];
      let its = this.textInputs.split("\n")
          .map(l => l.trim().split(/\s+/))
          .filter(a => a.length === 2)
          .map(o => {
            return {"number": o[0], "money": Number(o[1]), "researchMoney": Number(o[1]),"budgetFile": this.budgetFile}
          });
      this.parsedItems = its;
      this.item.budgetFile = this.budgetFile;
      return its;
    },

    //点击导入按钮开始导入项目信息
    impParsedItems() {
      let vm = this;
      let buf = []
      this.importing = true;
      this.parsedItems.forEach((it, i, a) => {
        vm.impMsg = `项目：${it.projNumber}， 检索中……`;
        this.axios.get(`${projURI}/${it.projNumber}`).then(rsp => {

            let proj = rsp.data;
            let claim = {
              "deptId": proj.deptId,
              "deptName": proj.department ? proj.department.name : "",
              "flbh": this.item.flbh,
              "fundPartitionId": it.fundPartitionId,
              "leaderId": proj.leaderId,
              "leaderName": proj.leaderName,
              "money": it.money,
              "researchMoney": it.researchMoney,
              "projLkxxId": this.item.dbid,
              "projName": proj.name,
              "projNumber": proj.number,
              "projTypeName": proj.type ? proj.type.name : '',
              "projectId": proj.dbid,
              "pznm": this.item.pznm,
              "budgetFile": it.budgetFile
          }

            vm.impMsg = `项目：${it.projNumber}, 导入成功，${claim.projName}`;

            buf.push(claim)

            if (i === a.length - 1) {
              vm.item.claimItems = buf
              vm.item.budgetFile = it.budgetFile
              vm.textInputs = "";
              vm.dialogImp = false;
              vm.excelDialogImp = false;
              vm.importing = false;
              vm.impMsg = "";
            }
        });
      });
    },

    onPartition() {
      //调用FundCwLkxxServlet中的put("/partition/:dbid")进行批量到款经费拆分
      const vm = this;
      this.axios.put(`${baseURI}/partition/${this.dbid}`, {})
          .then(rsp => {
            vm.item = rsp.data;
            alert("批量建帐完成！")
            vm.visible = false
          });
    },

    onPush() {
      const vm = this;
      this.axios.put(`${baseURI}/push/${this.dbid}`, {})
          .then(rsp => {
            vm.item = rsp.data;
          });
    },

    async ifProjectExist(tempProjNumber) {

      this.importing = true;
      let tflag = true
      let projIdErr = []
      for(let j=0;j<tempProjNumber.length;j++) {
        this.impMsg = `项目ID：${tempProjNumber[j].projNumber}， 校验中……`;
        await  this.axios.get(`${getProjUri}/${tempProjNumber[j].projNumber}`).then(rsp => {
          if (rsp.data === "false") {
            tflag = false
            projIdErr.push(`导入表格中项目ID："${tempProjNumber[j].projNumber}"在系统中不存在！`)
          }
        });
      }

      if(!tflag) {
        alert(projIdErr)
        this.impMsg = ''
        this.importing = false
        this.disnaImport = true
        this.excelDialogImp = false
      }
      else
      {
        this.importing = false
        this.disnaImport = false
      }
    },

    parseExcel() {
      let cmp = this;
      let inp = document.getElementById('_imp_text_file')
      let file = inp.files[0];
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        let workbook = read(data);
        let stName = workbook.SheetNames[0];
        let {sheet, range} = findSheet(workbook, stName);

        let {columns, firstRow} = findTable(sheet, range, {
          projNumber: "项目ID",
          projName: "项目名称",
          money: "到款金额（元）",
          researchMoney: "研究经费（元）"
        });

        let xlsxData = readTable(sheet, range, columns, firstRow, () => false);
        let validExcel = []
        let excelFlag = true
        // xlsxData.forEach((record, index) => {
        //   window.console.log(record);
        //   // to get a real date...
        //   // let xlsxData = convertExcelDate(record.date);
        // });

        //从xlsData缓冲数据中根据projNumber提取不空数据至parsedItems
        try {
        cmp.parsedItems = xlsxData.filter(v => v['projNumber'])
            .map(v => {
              return {
                "projNumber": v['projNumber'],
                "projName": v['projName'],
                "money": Number(v['money']).toFixed(2),
                "researchMoney": Number(v['researchMoney']).toFixed(2),
                "fundPartitionId": cmp.defaultPartId,
                "budgetFile": cmp.budgetFile
              }
            });
        } catch (error) {
          if (error == "RangeError: Invalid Date")
            validExcel.push("读取excel表格出错，表格中存在无效日期！")
          else
            validExcel.push("读取excel表格出错，表格中存在其它无效数据！")
          excelFlag = false
        }

        //判断导入excel文件各必须数据项是否为空
        let row = 1
        cmp.parsedItems.forEach((it) => {
          row = row + 1
          let tempNumber = it.projNumber
          if (it.projNumber == null || (tempNumber.replace(/\s*/g, '')).length === 0) {
            validExcel.push(`表格第${row}行` + "导入表格存在空的项目ID！")
            excelFlag = false
          }

          let tempName = it.projName
          if (it.projName == null || (tempName.replace(/\s*/g, '')).length === 0) {
            validExcel.push(`表格第${row}行` + "导入表格存在空的项目名称！")
            excelFlag = false
          }

          let tempIncome = it.money
          if (it.money == null || tempIncome == 0) {
            validExcel.push(`表格第${row}行` + "导入表格存在空的到款金额！")
            excelFlag = false
          }

          let tempResearchIncome = it.researchMoney
          if (it.researchMoney == null || tempResearchIncome == 0) {
            validExcel.push(`表格第${row}行` + "导入表格存在空的研究经费！")
            excelFlag = false
          }
        });

        //校验excel文件中项目类别、部门、学科、组织形式、研究活动类别信息
        if (!excelFlag) {
          alert(validExcel)
          cmp.excelDialogImp = false;
          cmp.validBtn = false;
        }
        else
        {
          //判断项目ID是否存在，确保数据一致性
          cmp.ifProjectExist(cmp.parsedItems)
        }

      };

      // 读取 EXCEL 文件
      reader.readAsArrayBuffer(file);
    },


    onDefaultPartIdChange() {
      this.disnaReadExcel = !(!!this.fileExcel && !!this.defaultPartId && !!this.item.lkbz);
    },

  }
}
</script>
